import React from "react";
import { Tab } from "@mui/material";
import { TOOL_ORDER, TOOL_LABELS } from "./toolRegistry";

export default function ToolDrawerTabs({ activeTools }) {
  return TOOL_ORDER.filter((id) => activeTools.includes(id)).map((id) => (
    <Tab key={id} label={TOOL_LABELS[id]} />
  ));
}
